import React, { useMemo } from "react";
import zip from "lodash/zip";
import uniq from "lodash/uniq";
import flattenDeep from "lodash/flattenDeep";
import MessageFavoriteFieldsContext from "views/components/contexts/MessageFavoriteFieldsContext";
import { useStore } from "stores/connect";
import { StreamsStore } from "views/stores/StreamsStore";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import { DEFAULT_FIELDS } from "../fields/hooks/useMessageFavoriteFieldsForEditing";
import useMessageFavoriteFieldsMutation from "../fields/hooks/useMessageFavoriteFieldsMutation";
const OriginalMessageFavoriteFieldsProvider = ({ children = null, message, messageFields }) => {
  var _a;
  const { streams: streamsList = [] } = useStore(StreamsStore);
  const { permissions } = useCurrentUser();
  const streams = useMemo(() => {
    var _a2, _b;
    const messageStreamIds = (_b = (_a2 = message == null ? void 0 : message.fields) == null ? void 0 : _a2.streams) != null ? _b : [];
    const streamsById = Object.fromEntries(
      streamsList.filter((stream) => isPermitted(permissions, `streams:read:${stream.id}`)).map((stream) => [stream.id, stream])
    );
    return messageStreamIds.map((id) => streamsById == null ? void 0 : streamsById[id]).filter((s) => !!s);
  }, [(_a = message == null ? void 0 : message.fields) == null ? void 0 : _a.streams, permissions, streamsList]);
  const initialFavoriteFields = useMemo(
    () => uniq(flattenDeep(zip(streams.map((stream) => {
      var _a2;
      return (_a2 = stream == null ? void 0 : stream.favorite_fields) != null ? _a2 : DEFAULT_FIELDS;
    })))),
    [streams]
  );
  const editableStreams = useMemo(
    () => streams.filter((stream) => isPermitted(permissions, `streams:edit:${stream.id}`)),
    [permissions, streams]
  );
  const { saveFavoriteField, toggleField, setFieldsIsPending } = useMessageFavoriteFieldsMutation(
    editableStreams,
    initialFavoriteFields
  );
  const contextValue = useMemo(
    () => ({
      favoriteFields: initialFavoriteFields,
      saveFavoriteField,
      messageFields,
      message,
      toggleField,
      editableStreams,
      setFieldsIsPending
    }),
    [
      initialFavoriteFields,
      saveFavoriteField,
      messageFields,
      message,
      toggleField,
      editableStreams,
      setFieldsIsPending
    ]
  );
  return /* @__PURE__ */ React.createElement(MessageFavoriteFieldsContext.Provider, { value: contextValue }, children);
};
const MessageFavoriteFieldsProvider = ({
  children = null,
  message,
  messageFields,
  isFeatureEnabled
}) => {
  if (!isFeatureEnabled) return children;
  return /* @__PURE__ */ React.createElement(OriginalMessageFavoriteFieldsProvider, { message, messageFields }, children);
};
export default MessageFavoriteFieldsProvider;
